<script setup>
import ProForecastListPage from '@/components/ProForecastListPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <ProForecastListPage />
  </Suspense>
  <ToastHost />
</template>
